<template>
  <v-dialog
    v-model="showModal"
    persistent
    max-width="700px"
    @keydown.esc.prevent="cancel()"
  >
    <v-card class="modalCard">
      <v-card-title class="modalTitle pt-2 pb-1 mb-2">
        <h2>{{ showTitle }}</h2>
      </v-card-title>
      <v-card-text class="pt-2 pb-2">
        <v-card class="mb-2 pb-2">
          <v-card-text>
            <el-radio-group
              class="my-0"
              required
              :items="roleList"
              v-model="roleObjekte"
            />
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions class="modalActions" elevation="5">
        <v-spacer></v-spacer>
        <el-button @click.native="cancelData()">
          {{ $t('Atšaukti') }}
        </el-button>
        <el-button
          primary
          @click.native.stop="saveData()"
          :disabled="disableSave"
        >
          {{ $t('Tęsti') }}
        </el-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ModalNtrPrasymasRole',
  props: {
    prasymasTipasFilter: String,
    value: Boolean,
  },
  data() {
    return {
      roleObjekte: null,
    }
  },
  computed: {
    isNuoma() {
      return this.prasymasTipasFilter.includes('nuoma')
    },
    isPanauda() {
      return this.prasymasTipasFilter.includes('panauda')
    },
    isSubnuoma() {
      return this.prasymasTipasFilter.includes('subnuomos')
    },
    isPreliminari() {
      return this.prasymasTipasFilter.includes('preliminari')
    },
    showTitle() {
      if (this.isPanauda) {
        return this.$t('Panaudos sutartyje Jūs:')
      }
      if (this.isSubnuoma) {
        return this.$t('Subnuomos sutartyje Jūs:')
      }
      if (this.isPreliminari) {
        return this.$t('Preliminariojoje sutartyje Jūs:')
      }
      return this.$t('Nuomos sutartyje Jūs:')
    },
    disableSave() {
      return this.roleObjekte === null
    },
    showModal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    roleList() {
      if (this.isPanauda) {
        return this.panaudaRoleList
      }
      if (this.isSubnuoma) {
        return this.subnuomaRoleList
      }
      if (this.isPreliminari) {
        return this.preliminariRoleList
      }
      return this.nuomaRoleList
    },
    nuomaRoleList() {
      return [
        {
          label: this.$t('Nuomotojas (turto savininkas)'),
          tooltip: 'NtrPaslaugos. Nuoma įregistravimas. Rolė nuomotojas',
          value: 'nuomotojas',
        },
        {
          label: this.$t('Nuomininkas'),
          tooltip: 'NtrPaslaugos. Nuoma įregistravimas. Rolė nuomininkas',
          value: 'nuomininkas',
        },
      ]
    },
    panaudaRoleList() {
      return [
        {
          label: this.$t('Panaudos davėjas (turto savininkas)'),
          tooltip:
            'NtrPaslaugos. Panauda įregistravimas. Rolė panaudos davėjas',
          value: 'panauda_davejas',
        },
        {
          label: this.$t('Panaudos gavėjas'),
          tooltip:
            'NtrPaslaugos. Panauda įregistravimas. Rolė panaudos gavėjas',
          value: 'panauda_gavejas',
        },
      ]
    },
    subnuomaRoleList() {
      return [
        {
          label: this.$t('Subnuomotojas'),
          tooltip: 'NtrPaslaugos. Subnuoma įregistravimas. Rolė subnuomotojas',
          value: 'subnuomotojas',
        },
        {
          label: this.$t('Subnuomininkas'),
          tooltip: 'NtrPaslaugos. Subnuoma įregistravimas. Rolė subnuomininkas',
          value: 'subnuomininkas',
        },
      ]
    },
    preliminariRoleList() {
      return [
        {
          label: this.$t('Pirkėjas'),
          tooltip: 'NtrPaslaugos. Preliminari įregistravimas. Rolė pirkėjas',
          value: 'pirkejas',
        },
        {
          label: this.$t('Pardavėjas'),
          tooltip: 'NtrPaslaugos. Preliminari įregistravimas. Rolė pardavėjas',
          value: 'pardavejas',
        },
      ]
    },
  },
  methods: {
    saveData() {
      this.$emit('confirmPrasymasRole', this.roleObjekte)
      this.closeModal()
    },
    cancelData() {
      this.closeModal()
    },
    closeModal() {
      this.showModal = false
    },
    submit() {
      this.saveData()
    },
    cancel() {
      this.closeModal()
    },
  },
}
</script>
<style lang="scss" scoped>
.modalCard {
  background: #f5f5f5;
}
.modalTitle {
  background: #f5f5f5 !important;
  position: sticky;
  top: 0;
  z-index: 2;
  background: none;
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
.modalActions {
  position: sticky;
  bottom: 0;
  z-index: 1;
}
</style>
